import styles from './MenuBarPill.module.css';
import { BareSvg } from '@/lib';
import IcArrowUpRight from '@/assets/icons/ic-arrow-up-right.svg';

import { cn } from '@/lib/utils/cn';
import { MenuBarPillProps } from '../types';

export function MenuBarPill({
    text,
    icon,
    className,
    removeFill = false,
    onClick,
    horizontalView,
    redirect,
}: MenuBarPillProps) {
    return (
        <div
            className={`${styles.container} ${className} ${horizontalView ? styles.horizontal : ''}`}
            onClick={onClick}
        >
            <BareSvg SvgComponent={icon} className={styles.svg} removeFill={removeFill} />
            <span className={styles['pill-text']}>{text}</span>
            {redirect && (
                <BareSvg
                    SvgComponent={IcArrowUpRight}
                    className={cn(styles.svg, styles.endIcon)}
                    removeFill={removeFill}
                />
            )}
        </div>
    );
}
